module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av236-1953a20a7fc82818844e590c5a8e3307.jpg";